import { ElMessageBox } from 'element-plus'

/**
 * @description 时间格式转换
 * @param strDate  时间
 * @param strFormat  小数点位数转换格式  默认"yyyy-MM-dd"
 * @param strFormat  小数点位数转换格式  默认"yyyy-MM-dd"
 * @param type   edit
 * 示例"yyyy/MM/dd","yyyy-MM-dd w HH-mm-ss","yyyy-MM-dd w" w为星期几
 */
export const myDate = (strDate: string | number | Date, strFormat: string = 'yyyy-MM-dd', type?: 'end'): string => {
	if (strDate === 99991231 && type === 'end') {
		return ''
	}
	if (!Boolean(strDate)) {
		return ''
	}
	// 如果是19000101字符串格式则返回空
	const strDateTypeString = typeof strDate === 'string'
	if (strDate === '1900/01/01') {
		return ''
	}
	try {
		const strDateNew = parseDate(strDate)
		type date = {
			yyyy: number
			M: number
			d: number
			H: number
			m: number
			s: number
			w: number
			yy: string
			MM: string | number
			dd: string | number
			HH: string | number
			mm: string | number
			ss: string | number
		}
		const date = {} as date
		date.yyyy = strDateNew.getFullYear()
		date.M = strDateNew.getMonth() + 1
		date.d = strDateNew.getDate()
		date.H = strDateNew.getHours()
		date.m = strDateNew.getMinutes()
		date.s = strDateNew.getSeconds()
		date.w = strDateNew.getDay()
		date.yy = date.yyyy.toString().substring(2, 4)
		date.MM = date.M < 10 ? '0' + date.M : date.M
		date.dd = date.d < 10 ? '0' + date.d : date.d
		date.HH = date.H < 10 ? '0' + date.H : date.H
		date.mm = date.m < 10 ? '0' + date.m : date.m
		date.ss = date.s < 10 ? '0' + date.s : date.s
		const weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
		let newDate = ''
		newDate = strFormat.replace('yyyy', date.yyyy.toString())
		newDate = newDate.replace('yy', date.yy)
		newDate = newDate.replace('MM', date.MM.toString())
		newDate = newDate.replace('M', date.M.toString())
		newDate = newDate.replace('dd', date.dd.toString())
		newDate = newDate.replace('d', date.d.toString())
		newDate = newDate.replace('HH', date.HH.toString())
		newDate = newDate.replace('H', date.H.toString())
		newDate = newDate.replace('mm', date.mm.toString())
		newDate = newDate.replace('m', date.m.toString())
		newDate = newDate.replace('ss', date.ss.toString())
		newDate = newDate.replace('s', date.s.toString())
		newDate = newDate.replace('w', weekday[date.w])
		try {
			if (strDateTypeString) {
				return newDate
					.replace('1900-01-01 00:00:00', '')
					.replace('1900-01-01 00:00', '')
					.replace('1900-01-01 00', '')
					.replace('1900-01-01', '')
			}
			return newDate
		} catch (error) {
			return newDate
		}
	} catch (e) {
		return strDate.toString()
	}
}

/**
 * @description 转换成时间格式
 * @param strDate  时间 string | Date
 */
export const parseDate = (strDate?: string | number | Date | null): Date => {
	if (strDate === null || strDate === 0) {
		// 默认初始化日期
		// throw new Error("strDate(" + strDate + ")")
	}
	if (typeof strDate === 'string') {
		// safari 不支持 2019-01-01 00:00:00.000 需要转换成 2019/01/01 00:00:00
		strDate = strDate.replace(/-/g, '/').replace(/\.[0-9]{3}/g, '')
		if (strDate.length === 8 && !strDate.includes('/')) {
			strDate = strDate.slice(0, 4) + '/' + strDate.slice(4, 6) + '/' + strDate.slice(6)
		}
	}
	if (typeof strDate === 'number') {
		const str = String(strDate)
		if (str.length === 8) {
			strDate = str.slice(0, 4) + '/' + str.slice(4, 6) + '/' + str.slice(6)
		} else {
			ElMessageBox.alert('日期格式不正确！' + strDate)
		}
	}

	return strDate ? new Date(strDate) : new Date()
}

/**
 * @description 判断是否时间格式
 * @param date  时间
 */
export const isDate = (date: string | Date): boolean => {
	if (isNaN(new Date(date).getTime())) {
		return false
	}
	if (Array.isArray(date)) {
		return false
	} // deal with `new Date([ new Date() ]) -> new Date()`
	return true
}

/**
 * @description 获取短日期 年月日
 * @param date  时间
 */
export const shortDate = (date: string | Date): string => {
	return myDate(date, 'yyyy-MM-dd')
}

/**
 * @description 获取长时间 年月日 时分秒
 * @param date  时间
 */
export const longDate = (date: string | Date): string => {
	return myDate(date, 'yyyy-MM-dd HH:mm:ss')
}

/**
 * @description 两个日期相差天数
 * @param date1  时间
 * @param date2  时间
 */
export const dayDiff = (date1: string | Date, date2: string | Date): number => {
	const oDate1: any = new Date(shortDate(date1)) // 转换为月-日-年格式?
	const oDate2: any = new Date(shortDate(date2))
	// eslint-disable-next-line radix
	const iDays: number = parseInt(((oDate1 - oDate2) / 1000 / 60 / 60 / 24).toString()) // 把相差的毫秒数转换为天数
	return iDays
}
/**
 * @description 两个时间相差分钟
 * @param date1  时间
 * @param date2  时间
 */
export const minDiff = (date1: string | Date, date2: string | Date): number => {
	const oDate1: any = new Date(longDate(date1)) // 转换为月-日-年格式
	const oDate2: any = new Date(longDate(date2))
	const iDays: number = parseInt(((oDate1 - oDate2) / 1000 / 60).toString()) // 把相差的毫秒数转换为分钟
	return iDays
}
/**
 * @description 加/减
 * @param type  时间年/月/日 Y/M/D
 * @param strDate  时间
 * @param num  加/减的数量
 * @param strFormat  时间返回格式
 */
type DateAdd = 'Y' | 'M' | 'D'
export const dateAdd = (type: DateAdd, strDate: string | Date, num: number, strFormat: string = 'yyyy-MM-dd') => {
	const d = parseDate(strDate)
	const n = Number(num || 0)
	if (type === 'Y') {
		d.setFullYear(d.getFullYear() + n)
	}
	if (type === 'M') {
		d.setMonth(d.getMonth() + n)
	}
	if (type === 'D') {
		d.setDate(d.getDate() + n)
	}
	return myDate(d, strFormat)
}

export const apiDate = (strDate: string | number | Date, type?: 'end'): number => {
	if (!Boolean(strDate) && type === 'end') {
		return 99991231
	}
	if (!Boolean(strDate)) {
		return 0
	}
	if (typeof strDate === 'number' && String(strDate).length === 8) {
		return Number(strDate)
	}
	if (typeof strDate === 'string' && strDate.length === 8) {
		return Number(strDate)
	}
	const resNumberDate = myDate(strDate, 'yyyyMMdd')
	if (resNumberDate.length === 8) {
		return Number(resNumberDate)
	} else {
		ElMessageBox.alert('日期格式不正确！' + strDate)
		return 0
	}
}
